import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { myhttp } from '@/utils/http';
import { getAppType, getClientType } from '@/utils/platform';
import { getUd } from '@/utils/device'; // 主接口

export function getVenueData() {
  return _getVenueData.apply(this, arguments);
} // 预约

function _getVenueData() {
  _getVenueData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ret;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return myhttp.get('/rest/o/production/activity/black/venue', {
              params: {
                visitor: getUd(),
                apptype: getAppType(),
                clientType: getClientType()
              }
            });

          case 2:
            ret = _context.sent;
            return _context.abrupt("return", ret);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getVenueData.apply(this, arguments);
}

export function appointment(_x, _x2) {
  return _appointment.apply(this, arguments);
} // 领取奖励

function _appointment() {
  _appointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(visitor, venueId) {
    var ret;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return myhttp.get('/rest/o/production/activity/black/appointment', {
              params: {
                visitor: visitor,
                venueId: venueId,
                apptype: getAppType()
              }
            });

          case 2:
            ret = _context2.sent;
            return _context2.abrupt("return", ret);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _appointment.apply(this, arguments);
}

export function receiveAward(_x3) {
  return _receiveAward.apply(this, arguments);
} // // 视频信息
// export async function getScrollPhoto(venueId:number): Promise<AjaxResponse<BlackMonthPhoto[]>> {
//     const ret = await myhttp.get<any, AjaxResponse<BlackMonthPhoto[]>>('/rest/o/production/activity/black/venue', {
//         params:{
//             venueId,
//             apptype:getAppType(),
//         },
//     } );
//     return ret;
// }

function _receiveAward() {
  _receiveAward = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(visitor) {
    var ret;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return myhttp.post('/rest/o/production/activity/black/receiveAward', {
              params: {
                visitor: visitor,
                apptype: getAppType()
              }
            });

          case 2:
            ret = _context3.sent;
            return _context3.abrupt("return", ret);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _receiveAward.apply(this, arguments);
}